<template>
  <div class="row mt-5 align-items-center">
    <div class="col-auto mr-4">
      <h4>Adicionais inclusos no plano</h4>
    </div>
    <div class="col-auto text-left">
      <router-link :to="{ name: 'mercado' }" class="btn btn-customizado btn-customizado-azul ml-2">
        Incluir Adicional
      </router-link>
    </div>
    <div class="col-12 mt-4">
      <table class="table table-responsive table-custom" >
        <thead class="thead fundo-cinza">
          <tr>
            <th class="p-3 border-0" width="80%">Serviço</th>
            <th class="p-3 text-center border-0">Quantidade</th>
            <th class="p-3 text-center border-0" width="20%">Valor unitario</th>
            <th class="p-3 text-center border-0">Total</th>
            <th class="p-3 text-center border-0">#</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in this.contratosAdicionais" :key="index">
            <td>{{ item["produto_nome"] }} - {{ item['plano_nome'] }}</td>
            <td class="text-center">{{ item.quantidade }}</td>
            <td class="text-center">{{ chamarFuncaoComParametros((item.valor * item.quantidade) / item.quantidade) }}</td>
            <td class="text-center">{{ chamarFuncaoComParametros(item.valor * item.quantidade) }}</td>
            <td class="text-center" v-if="item.plano_tipo === 1">
              <button
                :disabled="item.pedido_cancelamento"
                :class="item.pedido_cancelamento ? 'btn btn-customizado btn-customizado-vermelho texto-branco' : 'btn btn-customizado btn-customizado-transparente texto-azul'"
                @click="
                  modalVerificaCancelamento.abrirModalVerificaCancelamento(
                    item.contrato_id,
                    '0',
                    item
                  )
                "
              >
                {{ item.pedido_cancelamento ? 'Cancelado' : 'Cancelar' }}
              </button>
            </td>
          </tr>
           <tr v-if="this.contratosAdicionais.length === 0">
            <td colspan="100" class="text-center">Sem adicionais.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 fundo-cinza pb-3 pt-3  px-5">
      <div class="row">
        <div class="col-9 text-right gestaoConta-label-flex-column">
          <span class="texto-escuro">Valor dos adicionais: </span>
        </div>
        <div class="col-3 text-right gestaoConta-value-flex">
          <span class="texto-cinza">{{ chamarFuncaoComParametros(this.valorTotal) }}</span>
        </div>
      </div>
      <div class="row mb-2 mt-2">
        <div class="col-9 text-right gestaoConta-label-flex-column">
          <span class="texto-escuro">Valor do plano: </span>
        </div>
        <div class="col-3 text-right gestaoConta-value-flex">
          <span class="texto-cinza">{{ chamarFuncaoComParametros(this.resumoContrato.valor_total) }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-9 text-right gestaoConta-label-flex-column">
          <span class="texto-azul">Total: </span>
        </div>
        <div class="col-3 text-right gestaoConta-value-flex">
          <span class="texto-azul">{{  chamarFuncaoComParametros(parseFloat(this.resumoContrato.valor_total) + this.valorTotal) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  // Nao achei necessario criar um .js so pra pegar os props
  props: ['contratosAdicionais', 'valorTotal', 'modalVerificaCancelamento', 'formatarValorMonetario', 'resumoContrato'],
  methods: {
    chamarFuncaoComParametros (value) {
      return this.formatarValorMonetario(value)
    }
  }
}
</script>
